export default __webpack_public_path__ + "static/media/back.c8555a4c.svg";